import {enableProdMode, importProvidersFrom} from '@angular/core';
import {environment} from './environments/environment';
import {AppComponent} from './app/app.component';
import {GoogleMapsModule} from '@angular/google-maps';
import {provideEnvironmentNgxMask, NgxMaskConfig} from 'ngx-mask';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AppRoutingModule} from './app/app-routing.module';
import {BrowserModule, bootstrapApplication} from '@angular/platform-browser';
import {LoggingInterceptor} from './app/interceptors/logging.interceptor';
import {LoadingInterceptor} from './app/interceptors/loading.interceptor';
import {SessionInterceptor} from './app/interceptors/session.interceptor';
import {PortalCodeInterceptor} from './app/interceptors/portal-code.interceptor';
import {ParentDomainInterceptor} from './app/interceptors/parent-domain.interceptor';
import {HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient} from '@angular/common/http';
import {AppInsightsService} from './app/services/app-insights.service';
import {RECAPTCHA_SETTINGS, RecaptchaSettings, RecaptchaFormsModule, RecaptchaModule} from 'ng-recaptcha-2';
import {DatePipe, CommonModule} from '@angular/common';
import {PlansService} from './app/services/plans.service';
import {EventsManager} from './app/services/events.manager';
import {ConsumerPortalEnum, PURCHASE_FLOW_EVENT_HANDLER, WfPlansWidgetModule} from '@wellfit/wf-plans-widget';
import {SgdpGaEventHandler} from './app/services/sgdp-ga-event-handler.service';
import {PORTAL_CODE} from './app/interceptors/portal-code.interceptor';
import {PURCHASE_BASE_PATH, SGDP_BRANDING, SGDP_ORGANIZATION_ID} from './app/constants/purchase.constant';

const maskConfig: Partial<NgxMaskConfig> = {
  validation: false
};

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, CommonModule, AppRoutingModule, NgbModule, FormsModule, ReactiveFormsModule, RecaptchaFormsModule, RecaptchaModule, GoogleMapsModule),
    importProvidersFrom(
      WfPlansWidgetModule.forRoot({
        environment,
        options: {
          consumerPortal: ConsumerPortalEnum.SGDP,
          organizationId: SGDP_ORGANIZATION_ID,
          portalCode: PORTAL_CODE,
          basePath: PURCHASE_BASE_PATH,
          branding: SGDP_BRANDING
        }
      })
    ),
    {provide: PURCHASE_FLOW_EVENT_HANDLER, useClass: SgdpGaEventHandler},
    provideEnvironmentNgxMask(maskConfig),
    EventsManager, PlansService, DatePipe,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha.siteKey
      } as RecaptchaSettings
    },
    AppInsightsService,
    {provide: HTTP_INTERCEPTORS, useClass: SessionInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: PortalCodeInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ParentDomainInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true},
    provideHttpClient(withInterceptorsFromDi())
  ]
}).catch(err => console.error(err));
